import { render, staticRenderFns } from "./OperatorDashboardV2.vue?vue&type=template&id=67e741e5&scoped=true"
import script from "./OperatorDashboardV2.vue?vue&type=script&lang=js"
export * from "./OperatorDashboardV2.vue?vue&type=script&lang=js"
import style0 from "./OperatorDashboardV2.vue?vue&type=style&index=0&id=67e741e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e741e5",
  null
  
)

export default component.exports